import { createSlice } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from '../common/reducers/utilities';
import { resetNewJob } from './jobSlice';

export const clientConfig = createSlice({
    name: 'clientConfig',
    initialState: {
        config: {},
    },
    reducers: {
        set: (state, action) => {
            state.config = action.payload ?? {};
            state.isInApp = !!window.ReactNativeWebView;
            state.config.enableOfflineMode = state.isInApp ? state.config.enableOfflineMode : false;
        },
        updateSetting: (state, action) => {
            state.config[action.payload.key] = action.payload.value;
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => clientConfig.getInitialState());
    }
});


const fetchConfig = token => network => {
    network.get('/api/v1/clientConfig', clientConfig.actions.set).then(() => resetNewJob(network));
}
export const upsertSetting = (network, username, key, value) => {
    network.post('/api/v1/setting', { username, key , value }, clientConfig.actions.updateSetting);
}

const selectClientConfig = token => state => state.clientConfig.config;

const listen = {
    settingUpserted: (setting, { dispatch }) => dispatch(clientConfig.actions.updateSetting(setting)),
    invalidateConfig: (_, { network }) => network.get('/api/v1/clientConfig', clientConfig.actions.set)
}

export const [useClientConfigImpl] = dataHookFactory(selectClientConfig, initMapFactory(fetchConfig, listen, { allowEmpty: true, authenticated: false }));

const reducerDetails = { name: clientConfig.name, reducer: clientConfig.reducer };
export default reducerDetails;